import { render } from "./OrderReceiptComponent.vue?vue&type=template&id=de13d408"
import script from "./OrderReceiptComponent.vue?vue&type=script&lang=js"
export * from "./OrderReceiptComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/account/orderDetails/OrderReceiptComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "de13d408"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('de13d408', __exports__)) {
    api.reload('de13d408', __exports__)
  }
  
  module.hot.accept("./OrderReceiptComponent.vue?vue&type=template&id=de13d408", () => {
    api.rerender('de13d408', render)
  })

}


export default __exports__